import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ListSection from "../../components/ListSections/ListSections/ListSections.view";
import ListProduct from "../../components/ListProduct";
import Footer from "../../components/Footer";
import Splash from "../../components/Splash";
import InfoBar from "../../components/InfoBar/InfoBar.view";
import {
  setIsMobile,
  showAddressModal,
  showHorizontalSection,
  updateShopIsLoaded,
  updateUserLoyaltyPoints,
} from "../../redux/actions";
import {
  getClosedMessage,
  isQrCode,
  isSplash,
  isStringNotNull,
  getColors,
} from "../../utils";
import { loadLocalizeSdk } from "../../api";
import {
  displayOrNotHeader,
  handleScroll,
  updateDimensions,
} from "./Home.services";
import {
  BLOCK_CONTENT,
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
} from "../../constants";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import CloseBar from "./components/CloseBar";
import ThresholdMarketingProgress from "../../components/ThresholdMarkertingProgress/ThresholdMarketingProgress.view";
import { UPDATE_PENDING_ORDER } from "../../redux/actions/types";
import { CurrentOrdersNotification } from "../../components/CurrentOrders/components/CurrentOrdersNotification.view";
import { Box } from "@mui/material";
import { openMessageModal } from "../../utils/common";
import { getLoyaltyCashback } from "../../components/Loyalty/Loyalty.services";

export default function Home() {
  const dispatch = useAppDispatch();

  const { shopId: shopIdFromLink } = useParams();

  if (shopIdFromLink === "mentions-legales") {
    return <></>;
  }

  const [displaySectionsNavBar, setDisplaySectionsNavBar] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [executed, setExecuted] = useState(false);
  const {
    address: customerAddress,
    addressIsLoaded,
    shopId,
    isInit,
  } = useAppSelector((state) => state.pendingOrderReducer);

  useEffect(() => {
    const handleConfigFromLink = async () => {
      if (shopId === null) {
        dispatch({
          type: UPDATE_PENDING_ORDER,
          payload: {
            address: null,
            shopId: shopIdFromLink,
            orderType: ORDER_TYPE_DELIVERY,
          },
        });
        dispatch(showAddressModal(true));
      } else if (shopId !== shopIdFromLink) {
        dispatch({
          type: UPDATE_PENDING_ORDER,
          payload: {
            address: null,
            shopId: shopIdFromLink,
            orderType: ORDER_TYPE_CLICK_AND_COLLECT,
          },
        });
        dispatch(showAddressModal(true));
      }
    };

    if (isInit && isStringNotNull(shopIdFromLink)) handleConfigFromLink();
  }, [shopIdFromLink, isInit]);

  const { thresholdOffer } = useAppSelector((state) => state.offerReducer);

  const {
    isMobile,
    navbarHeight,
    overlayCover,
    isHorizontalSection,
    googleMapsEnabled,
    connexionModal,
    customerAddressCheck,
  } = useAppSelector((state) => state.componentReducer);
  const { sectionOrientation, loyalty } = useAppSelector(
    (state) => state.configurationReducer,
  );
  const { closed, shopIsLoaded, sections } = useAppSelector(
    (state) => state.shopReducer,
  );
  const { orders } = useAppSelector((state) => state.orderReducer);
  const { user, isUserAnonymous } = useAppSelector(
    (state) => state.userReducer,
  );
  const listSectionsRef = useRef(null);
  const displayNavBar =
    isHorizontalSection && (displaySectionsNavBar || isQrCode());
  displayOrNotHeader(displaySectionsNavBar || isQrCode());
  const displayOverlay = overlayCover === BLOCK_CONTENT;
  const showSplash = isSplash() && !shopIsLoaded;

  useEffect(() => {
    if (getLoyaltyCashback(loyalty)) return;

    updateUserLoyaltyPoints(user?.customerId, isUserAnonymous, dispatch);
  }, [loyalty, isUserAnonymous, user?.customerId]);

  useEffect(() => {
    const dimensionUpdate = () => updateDimensions();
    const scrollEvent = () =>
      handleScroll(
        listSectionsRef.current,
        displaySectionsNavBar,
        setDisplaySectionsNavBar,
      );

    loadLocalizeSdk();
    dispatch(
      setIsMobile(window.matchMedia("screen and (max-width: 700px)").matches),
    );
    window.addEventListener("scroll", scrollEvent);
    window.addEventListener("resize", dimensionUpdate);
    dispatch(showHorizontalSection());

    return () => {
      window.removeEventListener("scroll", scrollEvent);
      window.removeEventListener("resize", dimensionUpdate);
    };
  }, [listSectionsRef.current, displaySectionsNavBar]);

  useEffect(() => {
    dispatch(showHorizontalSection());
  }, [sectionOrientation]);

  useEffect(() => {
    if (
      overlayCover !== BLOCK_CONTENT &&
      !customerAddress &&
      googleMapsEnabled &&
      addressIsLoaded &&
      !isQrCode() &&
      !executed &&
      !isSplash() &&
      !connexionModal
    ) {
      setExecuted(true);
      dispatch(showAddressModal(true));
    }
  }, [
    overlayCover,
    customerAddress,
    googleMapsEnabled,
    addressIsLoaded,
    executed,
    connexionModal,
    addressIsLoaded,
    customerAddressCheck,
  ]);

  useEffect(() => {
    if (!customerAddress && addressIsLoaded && !shopIsLoaded) {
      dispatch(updateShopIsLoaded(true));
    }
  }, [customerAddress, addressIsLoaded, shopIsLoaded]);

  useEffect(() => {
    if (shopIsLoaded && customerAddress && isStringNotNull(closed)) {
      openMessageModal(getClosedMessage(closed));
    }
  }, [shopIsLoaded, customerAddress, closed]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });

    if (sections?.length) {
      setSelectedSection(sections[0]?.key);
    }
  }, [shopId]);

  const onTouchStart = () => {
    document.body.style.overflow = "hidden";
  };

  const onTouchEnd = () => {
    document.body.style.overflow = "visible";
  };
  const containerClassName = isHorizontalSection
    ? displayNavBar
      ? "fixed-top"
      : ""
    : `${displaySectionsNavBar || isQrCode() ? "fixed-top" : ""}`;

  const touchProps = isHorizontalSection ? { onTouchStart, onTouchEnd } : {};
  if (showSplash) return <Splash />;

  if (displayOverlay) return null;
  const padding = isMobile ? "16px" : "32px";
  const { bglightgrey } = getColors();
  const contentBoxSx = {
    paddingTop: displaySectionsNavBar || isQrCode() ? navbarHeight : "16px",
    paddingLeft: padding,
    paddingRight: padding,
    paddingBottom: padding,
    bgcolor: bglightgrey,
    flex: 1,
  };
  const isDesktopHorizontal = !(isHorizontalSection || isMobile);
  const showListSectionInTopBar = !isDesktopHorizontal;
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="container-fluid px-0"
        id="main-container"
        style={{ flex: 1, background: bglightgrey }}
      >
        <Box
          ref={listSectionsRef}
          className={containerClassName}
          id="info-bar"
          {...touchProps}
        >
          {shopIsLoaded && <CloseBar />}
          <InfoBar />
          {showListSectionInTopBar && (
            <ListSection
              setSelectedSection={setSelectedSection}
              selectedSection={selectedSection}
            />
          )}
          <CurrentOrdersNotification orders={orders} />
        </Box>
        <Box sx={{ display: isDesktopHorizontal ? "flex" : "block" }}>
          {isDesktopHorizontal && (
            <Box sx={{ bgcolor: bglightgrey }}>
              <ListSection
                setSelectedSection={setSelectedSection}
                selectedSection={selectedSection}
              />
            </Box>
          )}
          <Box sx={contentBoxSx}>
            <ListProduct
              setSelectedSection={setSelectedSection}
              isMobile={isMobile}
            />
          </Box>
        </Box>
      </div>
      <Footer />
      {thresholdOffer && <ThresholdMarketingProgress offer={thresholdOffer} />}
    </Box>
  );
}
